export function useYektanet() {
    const { isMrbilit } = useWhiteLabel();
    if (isMrbilit.value) {
        if (!import.meta.client || !(window as any).yektanet) {
            useScriptTag('/js/yektanet.js', () => {}, {
                async: true,
                defer: true,
                type: 'text/javascript',
                attrs: {
                    id: 'ua-script-yn-1493-adv',
                    'data-analyticsobject': 'yektanet',
                },
            });
        }
    }
}
